import { isTesting } from '../utils'

export const EXTERNAL_LOGIN_DOMAIN_WHITELIST = [
  'innoscripta.com',
  'clusterix.io',
  ...(isTesting() ? ['localhost'] : [])
]
